!(function () {
  "use strict";
  var e = {
      6072: function (e, t, r) {
        r.d(t, {
          Ds: function () {
            return i;
          },
          Q2: function () {
            return n;
          },
        });
        const n = function () {
          return {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
            },
          };
        };
        function i(e, t) {
          const r = this;
          let n;
          return function () {
            for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
              o[s] = arguments[s];
            (clearTimeout(n),
              (n = setTimeout(function () {
                return e.apply(r, o);
              }, t)));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            (e.preventDefault(), e.stopPropagation());
            const t = e.target.getAttribute("href");
            !(function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const r = document.getElementById("nav-wrapper"),
                n = document
                  .querySelector(".header")
                  .getAttribute("data-ux-position"),
                i = e.getBoundingClientRect().top;
              window.scrollTo({
                top:
                  "off" !== n
                    ? i + window.scrollY - t + parseFloat(r.style.marginTop)
                    : i + window.scrollY - t,
                behavior: "smooth",
              });
            })(document.querySelector(t));
          });
        });
      },
    },
    t = {};
  function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = (t[n] = { exports: {} });
    return (e[n](o, o.exports, r), o.exports);
  }
  ((r.d = function (e, t) {
    for (var n in t)
      r.o(t, n) &&
        !r.o(e, n) &&
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
  }),
    (r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = r(6072);
      const t = new (class {
        constructor() {
          ((this.selectorsToUpdate = [
            ".cart-summary__header",
            ".cart-summary__line-items",
            "#checkout",
            ".cart-summary__free-shipping",
          ]),
            (this.mainCartSelector = ".shopify-section.cart"),
            (this.miniCart = document.getElementById("mini-cart")),
            (this.itemsContainersSelector =
              ".cart-items-container, .cart__empty, .mini-cart--empty"),
            (this.parser = new DOMParser()),
            (this._desiredQtyByKey = new Map()),
            (this._inFlightByKey = new Set()),
            (this._inventoryBlockedByKey = new Set()),
            (this._maxQtyByKey = new Map()),
            (this._errorTimeoutByKey = new Map()),
            (this._versionByKey = new Map()),
            (this._deletingByKey = new Set()),
            (this.debugMode = !0),
            (this._needsCartRefresh = !1),
            (this.selectors = {
              cartItem: ".cart-item",
              cartItemTotals: ".cart-item__totals",
              priceItemSale: ".price-item--sale",
              priceItemRegular: ".price-item--regular",
              cartItemsContainer: ".cart-items-container",
              miniCart: "#mini-cart",
            }),
            (this.items = Array.from(document.querySelectorAll(".cart-item"))),
            this.items.forEach((e) => this.manageState(e)));
        }
        _getCartContainers() {
          const e = [],
            t = document.querySelector(this.mainCartSelector);
          t && e.push({ container: t, name: "mainCart", searchContainer: t });
          const r = document.getElementById("mini-cart");
          if (r) {
            const t = r.querySelector(this.selectors.cartItemsContainer);
            e.push({ container: r, name: "miniCart", searchContainer: t || r });
          }
          return e;
        }
        requestQuantityUpdate(e, t) {
          this._desiredQtyByKey.set(e, t);
          const r = this._versionByKey.get(e) || 0;
          this._versionByKey.set(e, r + 1);
          const n = this._maxQtyByKey.get(e);
          (this._inventoryBlockedByKey.has(e) &&
            void 0 !== n &&
            t <= n &&
            (this._inventoryBlockedByKey.delete(e),
            this.clearInventoryError(e)),
            this._inFlightByKey.has(e) || this._processItemUpdate(e));
        }
        async _processItemUpdate(e) {
          this._inFlightByKey.add(e);
          const t = this._desiredQtyByKey.get(e),
            r = this._versionByKey.get(e),
            n = document.querySelector(`.cart-item[data-item-id="${e}"]`);
          if (!n)
            return (
              this._inFlightByKey.delete(e),
              void this._desiredQtyByKey.delete(e)
            );
          const i = n.getAttribute("data-variant-id");
          this._setItemBusy(n, !0);
          try {
            (await this.changeCartItem({
              id: i,
              quantity: t,
              itemKey: e,
              requestVersion: r,
            }),
              this.clearInventoryError(e),
              this._inventoryBlockedByKey.delete(e));
          } catch (t) {
            if ((console.error("Cart update failed:", t), 429 === t.status))
              await new Promise((e) => setTimeout(e, 300));
            else if (422 === t.status) {
              try {
                const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
                  r = await fetch(t),
                  n = await r.text(),
                  i = this.parser.parseFromString(n, "text/html"),
                  o = i.querySelector(`.cart-item[data-item-id="${e}"]`);
                if (o) {
                  const t = o.querySelector('input[name="quantity"]'),
                    r = (t && parseInt(t.value)) || 1;
                  (this._maxQtyByKey.set(e, r),
                    this._desiredQtyByKey.set(e, r),
                    this._inventoryBlockedByKey.add(e),
                    this.showInventoryError(e, `Only ${r} available`),
                    await this.patchLineItem(e, i),
                    this.renderElements(i),
                    this.restoreOptimisticQuantities());
                }
              } catch (e) {
                console.error("Failed to fetch cart section after 422:", e);
              }
              return (
                this._setItemBusy(n, !1),
                void this._inFlightByKey.delete(e)
              );
            }
          } finally {
            (this._setItemBusy(n, !1), this._inFlightByKey.delete(e));
            const r = this._desiredQtyByKey.get(e);
            void 0 !== r && r !== t && this._processItemUpdate(e);
          }
        }
        _setItemBusy(e, t) {
          e &&
            [
              e.querySelector('button[name="plus"]'),
              e.querySelector('button[name="minus"]'),
              e.querySelector('input[name="quantity"]'),
            ].forEach((e) => {
              e &&
                (t
                  ? e.classList.add("is-busy")
                  : e.classList.remove("is-busy"));
            });
        }
        async patchLineItem(e, t) {
          let r =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : null;
          try {
            if (!t)
              return void console.error(
                `[Cart] patchLineItem: parsedSection is null/undefined for ${e}`,
              );
            const n = t.querySelector(
              `${this.selectors.cartItem}[data-item-id="${e}"]`,
            );
            if (!n && !r)
              return void console.warn(
                `[Cart] patchLineItem: Server item not found for key ${e} and no manual calc data`,
              );
            let i = null;
            if (
              n &&
              ((i = n.querySelector(this.selectors.cartItemTotals)), !i && !r)
            )
              return void console.warn(
                `[Cart] patchLineItem: Server totals not found for key ${e}`,
              );
            if (r) {
              const n = this._getCartContainers();
              let o = null,
                s = null;
              for (const { searchContainer: t, name: r } of n) {
                const r = t.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (r) {
                  let e = r.querySelector(
                      ".text-md.show-desktop " + this.selectors.priceItemSale,
                    ),
                    t = r.querySelector(".text-md.show-desktop s");
                  if (
                    ((e && t) ||
                      ((e = r.querySelector(
                        ".text-md " + this.selectors.priceItemSale,
                      )),
                      (t = r.querySelector(".text-md s"))),
                    !e || !t)
                  ) {
                    const n = r.querySelectorAll(this.selectors.priceItemSale);
                    for (const r of n)
                      if (!r.closest(this.selectors.cartItemTotals)) {
                        e = r;
                        const n = r.closest("dl, div");
                        n && (t = n.querySelector("s"));
                        break;
                      }
                  }
                  if (e && t) {
                    ((o = e.textContent.trim()), (s = t.textContent.trim()));
                    break;
                  }
                }
              }
              if (o && s) {
                const e = (e) => {
                    const t = e.replace(/[^\d.,]/g, "");
                    if (t.includes(",") && !t.includes("."))
                      return parseFloat(t.replace(",", "."));
                    if (t.includes(",") && t.includes(".")) {
                      const e = t.split(",");
                      if (2 === e.length && e[1].length <= 2)
                        return parseFloat(
                          t.replace(/\./g, "").replace(",", "."),
                        );
                    }
                    return parseFloat(t.replace(/,/g, ""));
                  },
                  n = (e(o), e(s) * r.requestedQty),
                  a = r.calculatedLinePrice,
                  c = (e) => {
                    const t = o.match(/[\d,]+\.?\d*/);
                    if (!t) return e.toFixed(2);
                    const r = t[0],
                      n = o.substring(0, o.indexOf(r)),
                      i = o.substring(o.indexOf(r) + r.length),
                      s =
                        o.includes(",") &&
                        (!o.includes(".") || o.indexOf(",") > o.indexOf(".")),
                      a =
                        r.includes(".") || r.includes(",")
                          ? r.split(/[.,]/)[1]?.length || 2
                          : 0;
                    let c = e.toFixed(a);
                    if (s) {
                      c = c.replace(".", ",");
                      const e = c.split(",");
                      (e[0].length > 3 &&
                        (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")),
                        (c = e.join(",")));
                    } else {
                      const e = c.split(".");
                      (e[0].length > 3 &&
                        (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")),
                        (c = e.join(".")));
                    }
                    return n + c + i;
                  },
                  l = `\n            <span class="text-xs show-mobile">Subtotal</span>\n            <span class="total-price">\n              <dl>\n                <dt class="visually-hidden">Regular price</dt>\n                <dd class="price-item--regular">\n                  <s class="text-xs">${c(n)}</s>\n                </dd>\n                <dt class="visually-hidden">Sale price</dt>\n                <dd class="price-item--sale">${c(a)}</dd>\n              </dl>\n            </span>\n          `;
                i ? (i.innerHTML = l) : (t._calculatedTotalsHTML = l);
              } else
                console.warn(
                  "[Cart] Could not find per-unit prices for manual calculation",
                );
            }
            if (!i && !t._calculatedTotalsHTML)
              return void console.warn(
                "[Cart] patchLineItem: Cannot proceed without serverTotals or calculated HTML",
              );
            let o = null;
            (i
              ? (o = i.innerHTML)
              : t._calculatedTotalsHTML && (o = t._calculatedTotalsHTML),
              this._getCartContainers().forEach((r) => {
                let { searchContainer: s, name: a } = r;
                const c = s.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (!c) return;
                const l = c.querySelector(this.selectors.cartItemTotals);
                if (l && o) {
                  let e = null,
                    r = null;
                  if (i)
                    ((e = i.querySelector(this.selectors.priceItemSale)),
                      (r = i.querySelector(this.selectors.priceItemRegular)));
                  else if (t._calculatedTotalsHTML) {
                    const n = document.createElement("div");
                    ((n.innerHTML = t._calculatedTotalsHTML),
                      (e = n.querySelector(this.selectors.priceItemSale)),
                      (r = n.querySelector(this.selectors.priceItemRegular)));
                  }
                  const n = l.querySelector(this.selectors.priceItemSale),
                    s = n?.textContent.trim() || null,
                    a =
                      l
                        .querySelector(this.selectors.priceItemRegular)
                        ?.textContent.trim() || null,
                    c = e?.textContent.trim() || null,
                    d = r?.textContent.trim() || null;
                  (s !== c || a !== d || n || e || !n) &&
                    ((l.innerHTML = o),
                    l
                      .querySelectorAll(".icon")
                      .forEach((e) => e.classList.add("loaded")));
                } else
                  l ||
                    console.warn(
                      `[Cart] patchLineItem: Current totals not found for key ${e} in ${a}`,
                    );
                if (n) {
                  const e = c.querySelector(".cart-item__discounts"),
                    t = n.querySelector(".cart-item__discounts");
                  if (t)
                    if (e)
                      ((e.innerHTML = t.innerHTML),
                        e
                          .querySelectorAll(".icon")
                          .forEach((e) => e.classList.add("loaded")));
                    else {
                      const e = c.querySelector(".cart-item__title");
                      if (e) {
                        const r = t.cloneNode(!0);
                        (e.appendChild(r),
                          r
                            .querySelectorAll(".icon")
                            .forEach((e) => e.classList.add("loaded")));
                      }
                    }
                  else e && e.remove();
                }
              }));
          } catch (t) {
            (console.error(`[Cart] Error in patchLineItem for ${e}:`, t),
              console.error("[Cart] Error stack:", t.stack));
          }
        }
        restoreOptimisticQuantities() {
          this._desiredQtyByKey.forEach((e, t) => {
            this._inventoryBlockedByKey.has(t) ||
              this._getCartContainers().forEach((r) => {
                let { searchContainer: n } = r;
                const i = n.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${t}"]`,
                );
                if (!i) return;
                const o = i.querySelector('input[name="quantity"]');
                if (!o) return;
                const s = this._maxQtyByKey.get(t),
                  a = void 0 !== s ? Math.min(e, s) : e;
                (parseInt(o.value) || 1) !== a && (o.value = a);
              });
          });
        }
        showInventoryError(e, t) {
          const r = this._errorTimeoutByKey.get(e);
          (r && clearTimeout(r),
            this._getCartContainers().forEach((r) => {
              let { searchContainer: n } = r;
              const i = n.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              if (!i) return;
              const o = i.querySelector(".cart-item__error");
              o && ((o.textContent = t), (o.style.display = "block"));
            }));
          const n = setTimeout(() => {
            const r = this._desiredQtyByKey.get(e),
              n = this._maxQtyByKey.get(e);
            void 0 === r || void 0 === n || r <= n
              ? this.clearInventoryError(e)
              : this.showInventoryError(e, t);
          }, 4e3);
          this._errorTimeoutByKey.set(e, n);
        }
        clearInventoryError(e) {
          const t = this._errorTimeoutByKey.get(e);
          (t && (clearTimeout(t), this._errorTimeoutByKey.delete(e)),
            this._getCartContainers().forEach((t) => {
              let { searchContainer: r } = t;
              const n = r.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              if (!n) return;
              const i = n.querySelector(".cart-item__error");
              i && ((i.textContent = ""), (i.style.display = "none"));
            }));
        }
        _removeDeleteClass(e) {
          this._getCartContainers().forEach((t) => {
            let { searchContainer: r } = t;
            const n = r.querySelector(
              `${this.selectors.cartItem}[data-item-id="${e}"]`,
            );
            n && n.classList.remove("is-deleting");
          });
        }
        _animateItemRemoval(e) {
          return new Promise((t) => {
            if (!e) return void t();
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
              return (e.remove(), void t());
            const r = e.offsetHeight;
            ((e.style.height = `${r}px`),
              (e.style.overflow = "hidden"),
              e.setAttribute("aria-live", "polite"),
              e.setAttribute("aria-atomic", "true"),
              e.offsetHeight,
              requestAnimationFrame(() => {
                (e.classList.add("cart-item--removing"),
                  setTimeout(() => {
                    (e.remove(), t());
                  }, 300));
              }));
          });
        }
        removeEventListeners(e) {
          const t = e.querySelector(".cart-item-delete, .cart-item__remove"),
            r = e.querySelector('button[name="plus"]'),
            n = e.querySelector('button[name="minus"]'),
            i = e.querySelector('input[name="quantity"]');
          (t &&
            t._deleteHandler &&
            t.removeEventListener("click", t._deleteHandler),
            r &&
              r._clickHandler &&
              r.removeEventListener("click", r._clickHandler),
            n &&
              n._clickHandler &&
              n.removeEventListener("click", n._clickHandler),
            i &&
              (i._changeHandler &&
                i.removeEventListener("change", i._changeHandler),
              i._keypressHandler &&
                i.removeEventListener("keypress", i._keypressHandler)));
        }
        manageState(e) {
          this.removeEventListeners(e);
          const t = e.getAttribute("data-item-id"),
            r = e.getAttribute("data-variant-id"),
            n = e.getAttribute("data-max-qty");
          if (n && !this._maxQtyByKey.has(t)) {
            const e = parseInt(n);
            !isNaN(e) && e > 0 && this._maxQtyByKey.set(t, e);
          }
          const i = e.querySelector(".cart-item-delete, .cart-item__remove");
          if (i) {
            const e = async () => {
              if (this._deletingByKey.has(t))
                this.debugMode &&
                  console.log(
                    `[Cart] Delete already in progress for ${t}, ignoring duplicate request`,
                  );
              else
                try {
                  (this._deletingByKey.add(t),
                    this._getCartContainers().forEach((e) => {
                      let { searchContainer: r } = e;
                      const n = r.querySelector(
                        `${this.selectors.cartItem}[data-item-id="${t}"]`,
                      );
                      n && n.classList.add("is-deleting");
                    }),
                    console.log(`[Cart] Starting delete for ${t}`),
                    console.log(
                      `[Cart] Fetching current cart state to find correct line number for ${t}`,
                    ));
                  const e = await fetch("/cart.js"),
                    n = (await e.json()).items.findIndex((e) => e.key === t);
                  if (-1 === n)
                    return (
                      console.warn(
                        `[Cart] Item ${t} not found in current cart, may already be deleted`,
                      ),
                      void this._getCartContainers().forEach((e) => {
                        let { searchContainer: r } = e;
                        const n = r.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${t}"]`,
                        );
                        n && n.remove();
                      })
                    );
                  const i = n + 1;
                  let o;
                  console.log(
                    `[Cart] Item ${t} is at line ${i} (was stored as line ${r})`,
                  );
                  try {
                    ((o = await this.changeCartItem({ id: i, quantity: 0 })),
                      console.log(
                        "[Cart] Delete request successful, response:",
                        o,
                      ));
                  } catch (e) {
                    if (
                      (console.error(
                        `[Cart] changeCartItem failed for ${t}:`,
                        e,
                      ),
                      429 !== e.status)
                    )
                      return 422 === e.status
                        ? (console.error(
                            `[Cart] Server validation error (422) for ${t} - item NOT deleted, keeping in cart`,
                          ),
                          void this._removeDeleteClass(t))
                        : (console.error(
                            `[Cart] Unexpected error for ${t} - item may still be in cart`,
                          ),
                          void this._removeDeleteClass(t));
                    (console.warn(
                      `[Cart] Rate limited (429) for ${t}, waiting 500ms then retrying...`,
                    ),
                      await new Promise((e) => setTimeout(e, 500)));
                    try {
                      ((o = await this.changeCartItem({ id: r, quantity: 0 })),
                        this.debugMode &&
                          console.log(
                            `[Cart] Retry after rate limit successful for ${t}`,
                          ));
                    } catch (e) {
                      return (
                        console.error(`[Cart] Retry failed for ${t}:`, e),
                        void this._removeDeleteClass(t)
                      );
                    }
                  }
                  if (o) {
                    const e = 0 === o.item_count;
                    this.debugMode &&
                      console.log(
                        `[Cart] Removing item ${t} from all containers (${o.item_count} items remain, isLastItem: ${e})`,
                      );
                    const r = this._getCartContainers();
                    this.debugMode &&
                      console.log(
                        `[Cart] Found ${r.length} cart containers to update`,
                      );
                    const n = r.map((e) => {
                      let { searchContainer: r, name: n } = e;
                      const i = r.querySelector(
                        `${this.selectors.cartItem}[data-item-id="${t}"]`,
                      );
                      return i
                        ? (this.debugMode &&
                            console.log(`[Cart] Removing item ${t} from ${n}`),
                          this._animateItemRemoval(i))
                        : (this.debugMode &&
                            console.log(`[Cart] Item ${t} not found in ${n}`),
                          Promise.resolve());
                    });
                    (await Promise.all(n),
                      this._desiredQtyByKey.delete(t),
                      this._inFlightByKey.delete(t),
                      this._inventoryBlockedByKey.delete(t),
                      this._maxQtyByKey.delete(t),
                      this._versionByKey.delete(t));
                    const i = this._errorTimeoutByKey.get(t);
                    (i && (clearTimeout(i), this._errorTimeoutByKey.delete(t)),
                      e &&
                        this.debugMode &&
                        console.log(
                          "[Cart] Last item removed, empty state should be visible",
                        ));
                  } else
                    console.error(
                      "[Cart] Delete operation failed - no response received",
                    );
                } catch (e) {
                  console.error(`[Cart] Error deleting item ${t}:`, e);
                } finally {
                  (this._deletingByKey.delete(t),
                    this.debugMode &&
                      console.log(
                        `[Cart] Delete operation completed for ${t}`,
                      ));
                }
            };
            ((i._deleteHandler = e), i.addEventListener("click", e));
          }
          if (!e.querySelector('input[name="quantity"]')) return;
          const o = e.querySelector('button[name="plus"]'),
            s = e.querySelector('button[name="minus"]'),
            a = e.querySelector('input[name="quantity"]'),
            c = () => {
              const e = parseInt(a.value) || 1,
                r = this._maxQtyByKey.get(t),
                n = void 0 !== r ? Math.min(r, e + 1) : e + 1;
              n !== e || void 0 === r
                ? ((a.value = n), this.requestQuantityUpdate(t, n))
                : this.showInventoryError(t, `Only ${r} available`);
            },
            l = () => {
              const e = parseInt(a.value) || 1,
                r = Math.max(1, e - 1);
              r !== e && ((a.value = r), this.requestQuantityUpdate(t, r));
            },
            d = (e) => {
              const r = parseInt(e.target.value);
              let n = isNaN(r) || r < 1 ? 1 : r;
              const i = parseInt(a.value) || 1,
                o = this._maxQtyByKey.get(t);
              (void 0 !== o &&
                n > o &&
                ((n = o), this.showInventoryError(t, `Only ${o} available`)),
                (n === i && a.value === String(n)) ||
                  ((a.value = n), this.requestQuantityUpdate(t, n)));
            },
            u = (e) => {
              ((8 !== e.which && 0 !== e.which && e.which < 48) ||
                e.which > 57) &&
                e.preventDefault();
            };
          (o && ((o._clickHandler = c), o.addEventListener("click", c)),
            s && ((s._clickHandler = l), s.addEventListener("click", l)),
            (a._changeHandler = d),
            a.addEventListener("change", d),
            (a._keypressHandler = u),
            a.addEventListener("keypress", u));
        }
        async changeCartItem(t) {
          const r = {
            ...(0, e.Q2)(),
            body: JSON.stringify({
              line: +t.id,
              quantity: t.quantity,
              sections: "main-cart",
            }),
          };
          return fetch(`${routes.cartChange}`, r)
            .then((e) => {
              if (!e.ok && 429 === e.status) {
                const e = new Error("Rate limited");
                throw ((e.status = 429), e);
              }
              if (!e.ok && 422 === e.status) {
                const e = new Error("Item already deleted or invalid");
                throw ((e.status = 422), e);
              }
              if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`);
              return e.json();
            })
            .then(async (e) => {
              const r = async (r, n) => {
                let i = this.parser.parseFromString(r, "text/html");
                if (n && e.item_count > 0) {
                  const e = i.querySelector(`.cart-item[data-item-id="${n}"]`),
                    r = e && e.querySelector(".cart-item__totals"),
                    o = r && r.querySelector(".price-item--sale"),
                    s = document.querySelector(
                      `.cart-item[data-item-id="${n}"]`,
                    ),
                    a = s && s.querySelector(".cart-item__totals"),
                    c = a && a.querySelector(".price-item--sale");
                  if (o || c) {
                    const r = t.quantity,
                      o = e && e.querySelector('input[name="quantity"]'),
                      s = (o && parseInt(o.value)) || 1;
                    if (e && s === r);
                    else {
                      const e = this._getCartContainers();
                      let t = null;
                      for (const { searchContainer: r } of e) {
                        const e = r.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${n}"]`,
                        );
                        if (e) {
                          let r = e.querySelector(
                            ".text-md.show-desktop " +
                              this.selectors.priceItemSale,
                          );
                          if (
                            (r ||
                              (r = e.querySelector(
                                ".text-md " + this.selectors.priceItemSale,
                              )),
                            !r)
                          ) {
                            const t = e.querySelectorAll(
                              this.selectors.priceItemSale,
                            );
                            for (const e of t)
                              if (!e.closest(this.selectors.cartItemTotals)) {
                                r = e;
                                break;
                              }
                          }
                          if (r) {
                            const e = r.textContent
                              .trim()
                              .replace(/[^\d.,]/g, "");
                            if (e.includes(",") && !e.includes("."))
                              t = parseFloat(e.replace(",", "."));
                            else if (e.includes(",") && e.includes(".")) {
                              const r = e.split(",");
                              t =
                                2 === r.length && r[1].length <= 2
                                  ? parseFloat(
                                      e.replace(/\./g, "").replace(",", "."),
                                    )
                                  : parseFloat(e.replace(/,/g, ""));
                            } else t = parseFloat(e.replace(/,/g, ""));
                            if (!isNaN(t)) break;
                          }
                        }
                      }
                      if (null !== t) {
                        const e = t * r;
                        ((i._needsManualPriceCalc = !0),
                          (i._calculatedLinePrice = e),
                          (i._requestedQty = r));
                      }
                    }
                  }
                }
                if (0 === e.item_count) {
                  console.log("[Cart] Cart is empty, rendering empty state");
                  const e = document.querySelector(this.mainCartSelector);
                  if (e) {
                    const t = i.querySelector(this.mainCartSelector);
                    t
                      ? (console.log(
                          "[Cart] Updating main cart with empty state HTML",
                        ),
                        (e.innerHTML = t.innerHTML))
                      : console.warn(
                          `[Cart] Could not find main cart selector "${this.mainCartSelector}" in parsed content`,
                        );
                  } else
                    console.log("[Cart] No main cart element found on page");
                  this.renderElements(i);
                } else if ((this.renderElements(i), n)) {
                  const e = i._needsManualPriceCalc
                    ? {
                        calculatedLinePrice: i._calculatedLinePrice,
                        requestedQty: i._requestedQty,
                      }
                    : null;
                  await this.patchLineItem(n, i, e);
                }
                this.restoreOptimisticQuantities();
              };
              if (e.sections && null !== e.sections["main-cart"])
                await r(e.sections["main-cart"], t.itemKey);
              else {
                const e = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`;
                await fetch(e)
                  .then((e) => e.text())
                  .then(async (e) => {
                    await r(e, t.itemKey);
                  });
              }
              const n = `${window.location.pathname}?section_id=navigation-main`;
              return fetch(n)
                .then((e) => e.text())
                .then((t) => {
                  if (
                    (this.parser.parseFromString(t, "text/html"),
                    0 === e.item_count)
                  ) {
                    console.log(
                      "[Cart] Cart is now empty, manually updating mini-cart to empty state",
                    );
                    const e = document.querySelector("#mini-cart");
                    if (e) {
                      const t = e.querySelector(".cart-items-container");
                      t &&
                        (console.log("[Cart] Hiding cart-items-container"),
                        (t.style.display = "none"),
                        t.remove());
                      let r = e.querySelector(".mini-cart--empty");
                      if (r)
                        (console.log(
                          "[Cart] Found existing mini-cart--empty, making it visible",
                        ),
                          (r.style.display = "block"));
                      else {
                        console.log(
                          "[Cart] No mini-cart--empty found, checking mini-cart__content",
                        );
                        const t = e.querySelector(".mini-cart__content");
                        t &&
                          ((r = t.querySelector(".mini-cart--empty")),
                          r &&
                            (console.log(
                              "[Cart] Found mini-cart--empty in content, making visible",
                            ),
                            (r.style.display = "block")));
                      }
                      (e.querySelectorAll(".cart-count").forEach((e) => {
                        e.textContent = "0";
                      }),
                        e.querySelectorAll(".cart-total-price").forEach((e) => {
                          e.textContent = "$0.00";
                        }));
                      const n = e.querySelector("#checkout");
                      n && (n.disabled = !0);
                      const i = e.querySelector(".cart-summary__free-shipping");
                      (i &&
                        ((i.style.display = "none"),
                        console.log(
                          "[Cart] Hidden free shipping calculator for empty cart",
                        )),
                        console.log(
                          "[Cart] ✓ Mini-cart manually updated to empty state",
                        ));
                    } else
                      console.log("[Cart] No mini-cart element found on page");
                  }
                  return e;
                });
            })
            .catch((e) => {
              throw (console.error(e), e);
            });
        }
        renderElements(e) {
          this.selectorsToUpdate.forEach((t) => {
            try {
              const r = document.querySelectorAll(t),
                n = e.querySelector(t);
              r.length &&
                n &&
                (n
                  .querySelectorAll(".icon")
                  .forEach((e) => e.classList.add("loaded")),
                r.forEach((e) => {
                  e.innerHTML = n.innerHTML;
                  if (n.hasAttribute("disabled")) {
                    e.setAttribute("disabled", "disabled");
                  } else {
                    e.removeAttribute("disabled");
                  }
                }));
            } catch (e) {
              console.error(`Error updating ${t}`, e);
            }
          });
          const t = e.querySelector(".cart-total-price");
          if (t) {
            const e = [],
              r = document.querySelector(this.mainCartSelector);
            (r && e.push(r),
              this.miniCart && e.push(this.miniCart),
              e.forEach((e) => {
                const r = e.querySelector(".cart-total-price");
                r && (r.innerHTML = t.innerHTML);
              }));
          }
          const r = e.querySelector(".cart-count");
          (document
            .querySelectorAll(
              "#cart-open-block .header__icons--cart-open .cart-count",
            )
            .forEach((e) => {
              r
                ? (e.classList.contains("visually-hidden") &&
                    e.classList.remove("visually-hidden"),
                  (e.textContent = r.textContent))
                : e.classList.add("visually-hidden");
            }),
            document
              .querySelector("#cart-open-block .icon")
              .classList.add("loaded"));
        }
        renderItems(e) {
          this.renderElements(e);
          const t = Array.from(
              document.querySelectorAll(this.itemsContainersSelector),
            ),
            r = e.querySelector(this.itemsContainersSelector);
          (t.forEach((e) => {
            e && e.replaceWith(r.cloneNode(!0));
          }),
            document.querySelectorAll(".cart-item").forEach((e) => {
              (e
                .querySelectorAll(".icon")
                .forEach((e) => e.classList.add("loaded")),
                this.manageState(e));
            }));
        }
        updateMiniCart(e) {
          return fetch(
            `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
          )
            .then((e) => e.text())
            .then((t) => {
              (this.renderItems(
                new DOMParser().parseFromString(t, "text/html"),
              ),
                e &&
                  "mini-cart" === cartStrings.uxCart &&
                  this.miniCart &&
                  this.miniCart.open());
            })
            .catch((e) => {
              console.error("Error updating mini cart:", e);
            });
        }
      })();
      ((window.cartService = t),
        (window.updateMiniCart = function () {
          return t.updateMiniCart(...arguments);
        }),
        customElements.get("cart-note") ||
          customElements.define(
            "cart-note",
            class extends HTMLElement {
              constructor() {
                (super(),
                  this.querySelector("textarea").addEventListener(
                    "change",
                    (0, e.Ds)((t) => {
                      const r = JSON.stringify({ note: t.target.value });
                      fetch(`${routes.cartUpdate}`, {
                        ...(0, e.Q2)(),
                        body: r,
                      });
                    }, 300),
                  ));
              }
            },
          ));
    })());
})();
